import Article1 from '../assets/article1.webp';
import Article11 from '../assets/article1-1.webp';
import Article2 from '../assets/article2.webp';
import Article2n1 from '../assets/Incapacidades.png';
import Article3 from '../assets/article3.webp';
import Article3n1 from '../assets/article3-1.webp';
import Article3n2 from '../assets/article3-2.webp';
import Article4 from '../assets/article4.webp';
import Article41 from '../assets/article4-1.webp';
import Article5 from '../assets/article5.webp';
import Article51 from '../assets/article5-1.webp';
import Article6 from '../assets/article6.webp';
import Article61 from '../assets/article6-1.webp';
import SeguroAuto from '../assets/seguroAuto.webp'
import CajaAhorro from '../assets/Botón-Caja-Ahorro.png';
import CajaAhorroInf from '../assets/CajadeAhorro-infografiaIZZI.png'
import Article7 from '../assets/article7.webp';
import Article13 from '../assets/article13.webp';
import Article14 from '../assets/article14.webp';
import Article15 from '../assets/article15.webp';
import Article16 from '../assets/article16.webp';
import Article17 from '../assets/article17.webp';
import Article18 from '../assets/article18.webp';
import Article19 from '../assets/article19.webp';
import Article20 from '../assets/article20.webp';
import Article21 from '../assets/article21.webp';
import Article22 from '../assets/article22.webp';
import Article23 from '../assets/article23.webp';
import Article24 from '../assets/article24.webp';
import Article25 from '../assets/article25.webp';
import Article26 from '../assets/article26.webp';
import Article27 from '../assets/article27.webp';
import Article28 from '../assets/article28.webp';
import Article29 from '../assets/article29.webp';
import Article30 from '../assets/article30.webp';
import Article31 from '../assets/article31.webp';
import Article32 from '../assets/article32.webp';
import Article33 from '../assets/article33.webp';
import Article331 from '../assets/article33-1.webp';
import Article34 from '../assets/article34.webp';
import Article341 from '../assets/article34-1.webp';
import Article35 from '../assets/article35.webp';
import Article351 from '../assets/article35-1.webp';
import Article36 from '../assets/article36.webp';
import Article37 from '../assets/article37.webp';
import Article38 from '../assets/article38.webp';
import Article39 from '../assets/article39.webp';
import Comedor1 from '../assets/Comedor1.webp';
import Comedor11 from '../assets/comedor1-1.webp';
import Comedor2 from '../assets/comedor2.webp';
import Comedor21 from '../assets/comedor2-1.webp';
import Comedor3 from '../assets/comedor3.webp';
import Comedor31 from '../assets/comedor3-1.webp';
import Transporte1 from '../assets/personal1.webp';
import NominaCC from '../assets/NóminaconCausa (1).png';
import SeguridadInf from '../assets/SEINF.png';
import SeguridadInf1 from '../assets/Seguridad de la información.png'
import { HomeDataType } from '../components/homecard/types';
import { ArticleData } from '../pages/article/types';
import { AgreementsData } from '../pages/listByAgreement/types';

import Enero from '../assets/calendario/Enero_Calendario.png';
import Febrero from '../assets/calendario/Febrero_Calendario.png';
import Marzo from '../assets/calendario/Marzo_Calendario.png';
import Abril from '../assets/calendario/ABRIL_Calendario.png';
import Mayo from '../assets/calendario/mayo_Calendario.png';
import Junio from '../assets/calendario/Junio_Calendario.png';
import Julio from '../assets/calendario/julio_Calendario.png';
import Agosto from '../assets/calendario/agosto_Calendario.png';
import Septiembre from '../assets/calendario/septiembre_Calendario.png';
import Octubre from '../assets/calendario/octubre_Calendario.png';
import Noviembre from '../assets/calendario/noviembre_Calendario.png';
import Diciembre from '../assets/calendario/diciembre_Calendario.png';
import Transporte from '../assets/Botón-Transporte.png';
import RutasTransporte from '../assets/Transporte.png';

export const homeCards: HomeDataType[] = [
    {
        id: 1,
        image: Article2,
        title: 'Reporta tus incapacidades',
        subtitle: undefined,
    },
    {
        id: 3,
        image: Article7,
        title: 'Nómina con Causa',
        subtitle: 'Nómina con Causa es el programa de los colaboradores de Grupo Televisa que, mediante una aportación voluntaria (semanal, decenal o quincenal), genera un fondo de apoyo para Campañas Masivas de Salud para los colaboradores y brinda atención a casos graves donde está en riesgo la vida.',
    },
    {
        id: 2,
        image: SeguridadInf,
        title: 'Seguridad de la Información',
        subtitle: undefined,
    },
];

export const comedores: HomeDataType[] = [
    {
        id: 8,
        image: Comedor1,
        title: 'Comedor Santa Fé',
        subtitle: '07/04/2025',
    },
    {
        id: 9,
        image: Comedor2,
        title: 'Comedor Chapultepec',
        subtitle: '07/04/2025',
    },
    {
        id: 10,
        image: Comedor3,
        title: 'Comedor San Angel',
        subtitle: '07/04/2025',
    }
];

export const beneficios: HomeDataType[] = [
    {
        id: 13,
        image: Article13,
        title: '50% de descuento en izzi residencial!',
        subtitle: 'Por ser colaborador izzi tienes el beneficio del 50% de descuento en tu cuenta de izzi residencial y obtenerlo es muy fácil:',
    },
    {
        id: 14,
        image: Article14,
        title: 'Tu vida mas izzi se siente',
        subtitle: 'https://izzitelco.sharepoint.com/sites/normatividad-izzi/SitePages/Videos-Seg-Info.aspx',
    },

]

export const agreements: AgreementsData ={
    autos: [
    {
        id: 15,
        image: Article15,
        title: 'National Car Rental',
        subtitle: 'Tarifas preferenciales fijas durante un año en la renta de automóviles. Prioridad en reservaciones. Servicio a domicilio sin costo. Atención personalizada por una ejecutiva de cuentas corporativas. Esta tarifa Incluye: Renta por día (24 hrs), Kilometraje ilimitado, Cobertura de protección total, TLP. Protección de daños a terceros, CDW. Protección de daños materiales (10% deducible), DP. Eliminación de Deducible de Daños Materiales, TP. Protección de Robo Total (10% deducible), PAI. Protección de gastos Médicos, RSP. Asistencia en el camino, I.V.A. No Incluye: Gasolina Faltante, Cuota aeroportuaria 18% ( si el auto se renta en aeropuerto). Productos adicionales que puedes contratar: Prepago de tanque de Gasolina, Dispositivo WIFI y Teléfono, Dispositivo de posicionamiento GPS, Asientos de Bebé, Conductor adicional, Conductor Menor.'
    },
    {
        id: 16,
        image: Article16,
        title: 'VW Santa Fe',
        subtitle: '5 mil pesos de descuento en la compra de autos semi-nuevos multimarca.'
    },
    {
        id: 17,
        image: Article17,
        title: 'VW Puerto Aereo',
        subtitle: 'En la compra de autos NUEVOS se otorgará el descuento como empresa estratégica que van desde un 2% hasta 6%. En la compra de unidades de autos semi nuevos de cualquier marca se otorgará 2% de descuento. 10% de descuento en la compra de refacciones y accesorios. Valet Parking e autos para Servicio en un radio de 10 Km.'
    },
    {
        id: 18,
        image: Article18,
        title: 'Suzuki Vallejo',
        subtitle: '3% de descuento especial Televisa en unidades nuevas (Ignis 1% y Fronx 2%). No aplica para JIMNY. Bono de $5,000 pesos en la compra de vehículos seminuevos. 15% de descuento en servicio y refacciones. Servicio de hojalatería express (previa cita y aplican restricciones). Desde 0% de enganche en operaciones a crédito con Scotibank. 6 meses sin intereses (sólo con Banamex) en pago de seguro y todo tipo de accesorios.'
    },
    {
        id: 19,
        image: Article19,
        title: 'Subaru Lomas Verdes e Interlomas',
        subtitle: '3% de descuento en la compra de unidades nuevas. $5,000.00 de bono adicional sobre precio propuesto al público en la toma de seminuevos. Descuento de $5,000.00 sobre precio al público en la compra de unidades semi nuevas. 10% de descuento en la compra de refacciones y servicio de mantenimiento.'
    },
    {
        id: 20,
        image: Article20,
        title: 'Soni',
        subtitle: '3% de descuento en la adquisición de unidades nuevas de cualquiera de las marcas.'
    },
    {
        id: 21,
        image: Article21,
        title: 'Renault San Cosme/ Grupo Witt',
        subtitle: 'Unidades Nuevas: 4% de descuento en la compra de unidades nuevas ya sea de contado o crédito. Si se adquiere por la financiera de la marca se ofrecerá enganche preferencial del 15% y un plazo máximo de 72 meses. Bono del 1% en la compra de semi-nuevos y garantía de 90 días naturales. Servicios: 15% de descuento en refacciones adicionales del área de servicio. En mantenimientos preventivos tiempos de entrega en mismo día y/o servicio de valet parking (aplican condiciones); diagnósticos con tiempo de respuesta máximo de 24 horas. solo CDMX y área conurbada. Certificado de lealtad con servicio de 40,000 Km sin costo (aplican condiciones). Precio preferencial en taller de hojalatería y pintura multimarca. Precios especiales en gestoría de emplacamiento de unidades nuevas.'
    },
    {
        id: 22,
        image: Article22,
        title: 'La Shaineada',
        subtitle: 'Promoción de 3 y 6 meses sin intereses para pagar todos sus servicios de detallado automotriz.'
    },
    {
        id: 23,
        image: Article23,
        title: 'Kia Iztapalapa',
        subtitle: '2% de descuento en la compra de unidades semi nuevas de inventario. En la compra de unidades nuevas KIA, se otorgara la instalación del Kit de seguridad (birlos y película de seguridad). Servicio de Valet Parking (máximo 10 Km a la redonda) para servicios de postventa del programa de garantía y reparaciones.'
    },
    {
        id: 24,
        image: Article24,
        title: 'Chirey Mundo E',
        subtitle: '3% de descuento o la aplicación de descuento o bono que ofrezca la marca cuando este sea mayor al 3%, aplicable en la compra de unidades nuevas. 2% de descuento sobre la lista de precios al público en la compra de unidades seminuevas. Bono de 5,000.00 (cinco mil pesos 00/100 MN), en la toma de unidades para la adquisición de un auto nuevo. 10% de descuento en la mano de obra en taller a excepción de los servicios preventivos de garantía. 10% de descuento en taller de HyP en la mano de obra para unidades de todas las marcas. 3% de descuento (vía mostrador) en la compra de refacciones.'
    },
    {
        id: 25,
        image: Article25,
        title: 'Car City',
        subtitle: '24% de descuento en la compra del sistema de localización GPS para todo tipo de vehículos, soporte y servicio post-venta.'
    },
    {
        id: 26,
        image: Article26,
        title: 'Camsa',
        subtitle: '10% de descuento en el precio del costo oficial en el servicio de verificación vehicular (primer intento).'
    },
    {
        id: 27,
        image: Article27,
        title: 'BYD Aeropuerto',
        subtitle: 'Unidades nuevas: 3% de descuento sobre precio de lista y colocación de película antiasalto. Seminuevos: 2% de descuento sobre el listado de precios al público. 10% de descuento en mano de obra de servicios (no preventivos). 10% de mano de obra de taller de Hojalatería y Pintura. 5% en la compra de refacciones y/o accesorios vía mostrador.'
    },
    {
        id: 28,
        image: Article28,
        title: 'BMW Vecsa',
        subtitle: 'Descuento del 7.5% en las líneas BMW y BMWi y del 6.5% en la línea MINI.'
    },
    {
        id: 29,
        image: Article29,
        title: 'Automotores Azcapotzalco',
        subtitle: '2% de descuento en la compra de autos seminuevos (VW y otras marcas). En adquisición de autos NUEVOS se otorgará el descuento que establece la planta cada mes. 10% de descuento en en mano de obra en reparaciones del taller, en reparaciones generales. NO APLICA en servicios preventivos.'
    },
    {
        id: 30,
        image: Article30,
        title: 'Audi Center López Mateos (Guadalajara)',
        subtitle: '2% de descuento adicional a la promoción/precio del mes, en la adquisición del inventario de unidades nuevas.'
    },
    {
        id: 31,
        image: Article31,
        title: 'Embragues y Frenos Ismael - Monterrey',
        subtitle: 'Obtén un 10% de descuento sobre el monto total en taller de servicio.'
    },
    {
        id: 32,
        image: Article32,
        title: 'Goodyear Coronado - CDMX',
        subtitle: 'Beneficios en la adquisición de llantas, amortiguadores, servicios para automóviles y camionetas.'
    },
    ],
    hola: []
}

export const cultura: HomeDataType[] = [
    {
        id: 33,
        image: Article33,
        title: 'Misión/Visión',
        subtitle: 'Comunicación RH el 26/05/2025'
    },
    {
        id: 34,
        image: Article34,
        title: 'Nuestros Principios',
        subtitle: 'Comunicación RH el 26/05/2025'
    },
    {
        id: 35,
        image: Article35,
        title: 'Nuestros Valores',
        subtitle: 'Comunicación RH el 26/05/2025'
    }
]

export const emergencies: HomeDataType[] = [
    {
        id: 36,
        image: Article36,
        title: 'Service Desk',
        subtitle: 'Comunicación RH el 28/05/2025'
    },
    {
        id: 37,
        image: Article37,
        title: 'Servicios de Emergencia',
        subtitle: 'Comunicación RH el 28/05/2025'
    },
    {
        id: 38,
        image: Article38,
        title: 'Atención GNP',
        subtitle: 'Comunicación RH el 28/05/2025'
    },
    {
        id: 39,
        image: Article39,
        title: 'Urgencias Metlife',
        subtitle: 'Comunicación RH el 28/05/2025'
    },
]


export const articles: ArticleData[] = [
    {
        id: 1,
        principalImage: Article2,
        title: 'Reporta tus incapacidades',
        date: '26/01/2026',
        images: [Article2n1],
        linkLabel: '',
        link: ''
    },
    {
        id: 2,
        principalImage: SeguridadInf,
        title: 'Seguridad de la Información',
        date: '26/01/2026',
        images: [SeguridadInf1],
        linkLabel: '',
        link: ''
    },
    {
        id: 3,
        principalImage: Article7,
        title: 'Nómina con Causa',
        date: '26/01/2026',
        images: [NominaCC],
        paragraphs: [
            'Nómina con Causa es el programa de los colaboradores de Grupo Televisa que, mediante una aportación voluntaria (semanal, decenal o quincenal), genera un fondo de apoyo para Campañas Masivas de Salud para los colaboradores y brinda atención a casos graves donde está en riesgo la vida.',
            'Estar afiliado al programa no sólo te beneficia a ti sino a tus familiares (cónyuge e hijos menores de 18 años) en caso de necesitarlo.',
            'A través del programa puedes recibir apoyo para adquirir:',
            'Silla de ruedas.',
            'Aparatos auditivos.',
            'Prótesis.',
            'Canastas de estimulación temprana.',
            'Acceso a concursos para conseguir becas para tus hijos.'
        ],
        linkLabel: 'https://nominaconcausa.org/',
        link: 'https://nominaconcausa.org/'
    },
    {
        id: 8,
        principalImage: Comedor1,
        title: 'Comedor Santa Fe',
        date: '07/04/2025',
        images: [Comedor11],
        linkLabel: '',
        link: ''
    },
    {
        id: 9,
        principalImage: Comedor2,
        title: 'Comedor Chapultepec',
        date: '07/04/2025',
        images: [Comedor21],
        linkLabel: '',
        link: ''
    },
    {
        id: 10,
        principalImage: Comedor3,
        title: 'Comedor San Angel',
        date: '07/04/2025',
        images: [Comedor31],
        linkLabel: '',
        link: ''
    },
    {
        id: 11,
        principalImage: CajaAhorro,
        title: 'Caja de Ahorro',
        date: '26/01/2026',
        images: [CajaAhorroInf],
        linkLabel: '',
        link: ''

    },
    {
        id: 12,
        principalImage: Transporte,
        title: 'Transporte de personal',
        date: '26/01/2026',
        images: [RutasTransporte],
        linkLabel: '',
        link: ''

    },
    {
        id: 13,
        principalImage: Transporte1,
        title: 'Transporte de personal',
        date: '26/06/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [' Para hacer uso de este beneficio, acude a Servicios Generales Edificio C, piso 2 con Maria Esther Olayo Flores (molayo@sky.com.mx)']
    },
    {
        id: 14,
        principalImage: Article13,
        title: '50% de descuento en izzi residencial!',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Por ser colaborador izzi tienes el beneficio del 50% de descuento en tu cuenta de izzi residencial y obtenerlo es muy fácil:',
            'Puedes gozar del beneficio en una cuenta de izzi y una cuenta de sky, siempre y cuando ambas estén instaladas en el mismo domicilio y registradas a tu nombre; de no ser así, solicita el cambio de titular.',
        ]
    },
    {
        id: 15,
        principalImage: Article13,
        title: 'Tu vida mas izzi se siente',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        videoLink: 'https://apprh.izzi.mx/apiv3/video/getIphoneSVideo/3381842/48871012.mp4/',
    },
    {
        id: 16,
        principalImage: Article15,
        title: 'National Car Rental',
        date: '14/03/2025',
        images: [],
        linkLabel: 'https://nationalcar.com.mx/',
        link: 'https://nationalcar.com.mx/',
        paragraphs: [
            'Tarifas preferenciales fijas durante un año en la renta de automóviles. Prioridad en reservaciones. Servicio a domicilio sin costo. Atención personalizada por una ejecutiva de cuentas corporativas. Esta tarifa Incluye: Renta por día (24 hrs), Kilometraje ilimitado, Cobertura de protección total, TLP. Protección de daños a terceros, CDW. Protección de daños materiales (10% deducible), DP. Eliminación de Deducible de Daños Materiales, TP. Protección de Robo Total (10% deducible), PAI. Protección de gastos Médicos, RSP. Asistencia en el camino, I.V.A. No Incluye: Gasolina Faltante, Cuota aeroportuaria 18% ( si el auto se renta en aeropuerto). Productos adicionales que puedes contratar: Prepago de tanque de Gasolina, Dispositivo WIFI y Teléfono, Dispositivo de posicionamiento GPS, Asientos de Bebé, Conductor adicional, Conductor Menor.',
            'Para reservar y gozar del beneficio deberás llamar al  800 716 6625 y mencionar el ID para Televisa: 3074 horario de atención de lunes a Viernes 08:00 a 21:00 hrs y sábados y domingos de 08:00 a 19:00 hrs.'
        ]
    },
    {
        id: 17,
        principalImage: Article16,
        title: 'VW Santa Fe',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '5 mil pesos de descuento en la compra de autos semi-nuevos multimarca.',
            'Juan Salvador Agraz 60, Col. Santa Fe, Cuajimalpa, CDMX. 05109'
        ]
    },
    {
        id: 18,
        principalImage: Article17,
        title: 'VW Puerto Aereo',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'En la compra de autos NUEVOS se otorgará el descuento como empresa estratégica que van desde un 2% hasta 6%. En la compra de unidades de autos semi nuevos de cualquier marca se otorgará 2% de descuento. 10% de descuento en la compra de refacciones y accesorios. Valet Parking e autos para Servicio en un radio de 10 Km.',
            'Blvd. Puerto Aéreo 107, Col. Federal, Alcaldía Venustiano Carranza, CDMX. 15700.',
        ]
    },
    {
        id: 19,
        principalImage: Article18,
        title: 'Suzuki Vallejo',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '3% de descuento especial Televisa en unidades nuevas (Ignis 1% y Fronx 2%). No aplica para JIMNY. Bono de $5,000 pesos en la compra de vehículos seminuevos. 15% de descuento en servicio y refacciones. Servicio de hojalatería express (previa cita y aplican restricciones). Desde 0% de enganche en operaciones a crédito con Scotibank. 6 meses sin intereses (sólo con Banamex) en pago de seguro y todo tipo de accesorios.',
            'Calz. Vallejo 1030, col. Industrial Vallejo, Azcapotzalco, México, D.F. 02300.',
        ]
    },
    {
        id: 20,
        principalImage: Article19,
        title: 'Subaru Lomas Verdes e Interlomas',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '3% de descuento en la compra de unidades nuevas. $5,000.00 de bono adicional sobre precio propuesto al público en la toma de seminuevos. Descuento de $5,000.00 sobre precio al público en la compra de unidades semi nuevas. 10% de descuento en la compra de refacciones y servicio de mantenimiento.',
            'Av. Lomas Verdes 545, Mz. 013, Colonia Lomas Verdes, Naucalpan de Juárez, Edo. de México. 53120. Tel. 55 8967 6250. Parque de Cádiz 2, Col. Parques de la Herradura, Naucalpan de Juárez, Edo. de México. 52786. Tel.  55 5350 4551.'
        ]
    },
    {
        id: 21,
        principalImage: Article20,
        title: 'Soni',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '3% de descuento en la adquisición de unidades nuevas de cualquiera de las marcas.',
            'Blvd. Adolfo Ruiz Cortines 4186, Col. Jardines del Pedregal, Alvaro Obregón, CDMX. 01900. Contacto: Leo Villagómez / Cel. 55 3660 0806.'
        ]
    },
    {
        id: 22,
        principalImage: Article21,
        title: 'Renault San Cosme/ Grupo Witt',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Unidades Nuevas: 4% de descuento en la compra de unidades nuevas ya sea de contado o crédito. Si se adquiere por la financiera de la marca se ofrecerá enganche preferencial del 15% y un plazo máximo de 72 meses. Bono del 1% en la compra de semi-nuevos y garantía de 90 días naturales. Servicios: 15% de descuento en refacciones adicionales del área de servicio. En mantenimientos preventivos tiempos de entrega en mismo día y/o servicio de valet parking (aplican condiciones); diagnósticos con tiempo de respuesta máximo de 24 horas. solo CDMX y área conurbada. Certificado de lealtad con servicio de 40,000 Km sin costo (aplican condiciones). Precio preferencial en taller de hojalatería y pintura multimarca. Precios especiales en gestoría de emplacamiento de unidades nuevas.',
            'Patriotismo: Av. Patriotismo 43, Col. Escandón I Secc., Alcaldía Miguel Hidalgo, CDMX. 11800. Polanco: Av. Ejército Nacional 1005, Col. Irrigación, Alcaldía Miguel Hidalgo, CDMX. 11500. San Cosme: Av. México Tenochtitlán 57, Col. Guerrero, Alcaldía Cuauhtémoc, CDMX. 06350.Tel. 55 5233 2020.',
        ]
    },
    {
        id: 23,
        principalImage: Article22,
        title: 'La Shaineada',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Promoción de 3 y 6 meses sin intereses para pagar todos sus servicios de detallado automotriz.',
            'Cerrada de Revolución 40, Col. 8 de Agosto, Alcaldía Benito Juárez, CDMX. 03820. Cotiza por WhatsApp: 55 8669 6967'
        ]
    },
    {
        id: 24,
        principalImage: Article23,
        title: 'Kia Iztapalapa',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '2% de descuento en la compra de unidades semi nuevas de inventario. En la compra de unidades nuevas KIA, se otorgara la instalación del Kit de seguridad (birlos y película de seguridad). Servicio de Valet Parking (máximo 10 Km a la redonda) para servicios de postventa del programa de garantía y reparaciones.',
            'Av. Leyes de Reforma 111, col. Paseos de Churubusco, Alcaldía Iztapalapa, CDMX.',
        ]
    },
    {
        id: 25,
        principalImage: Article24,
        title: 'Chirey Mundo E',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '3% de descuento o la aplicación de descuento o bono que ofrezca la marca cuando este sea mayor al 3%, aplicable en la compra de unidades nuevas. 2% de descuento sobre la lista de precios al público en la compra de unidades seminuevas. Bono de 5,000.00 (cinco mil pesos 00/100 MN), en la toma de unidades para la adquisición de un auto nuevo. 10% de descuento en la mano de obra en taller a excepción de los servicios preventivos de garantía. 10% de descuento en taller de HyP en la mano de obra para unidades de todas las marcas. 3% de descuento (vía mostrador) en la compra de refacciones.',
            'Blvd. Manuel Ávila Camacho 1994, San Lucas Tepetlacalco, Tlalnepantla de Baz, Estado de México. 54055. Contacto: Orlando Rodríguez Cruz / 55 1211-1484 / orlando.rodriguez@ismomotors.com'
        ]
    },
    {
        id: 26,
        principalImage: Article25,
        title: 'Car City',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '24% de descuento en la compra del sistema de localización GPS para todo tipo de vehículos, soporte y servicio post-venta.',
            'Instalación a domicilio en CDMX, Estado de México, Morelos, Hidalgo y Puebla.'
        ]
    },
    {
        id: 27,
        principalImage: Article26,
        title: 'Camsa',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '10% de descuento en el precio del costo oficial en el servicio de verificación vehicular (primer intento).',
            'TOREO MH01: Rodolfo Gaona 86, Col. Lomas de Sotelo, Miguel Hidalgo, CDMX. 11200 / cvvmh01@seyma.com.mx. COYOACAN CO24: Prol. Eje Central Lázaro Cárdenas 120, Col. La Candelaria, Coyoacán, CDMX. 04380. cvvco24@seyma.com.mx. VALLEJO AZ25: Coltongo 67, Col. Industrial Vallejo, Azcapotzalco, CDMX. 02630. cvvaz25@seyma.com.mx. CUAJIMALPA CJ26: Av. José María Castorena 525, Col. El Molino Cuajimalpa, Cuajimalpa, CDMX. 05240. cvvcj26@seyma.com.mx. GABRIEL MANCERA BJ27: Av. Gabriel Mancera 305, Col. Del Valle; Benito Juárez, CDMX. 03100. cvvbj27@seyma.com.mx. AV. TOLUCA AO28: Av. Toluca 147, Col. Olivar de Los Padres, Alvaro Obregón, CDMX. 01700. cvvao28@seyma.com.mx'
        ]
    },
    {
        id: 28,
        principalImage: Article27,
        title: 'BYD Aeropuerto',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Unidades nuevas: 3% de descuento sobre precio de lista y colocación de película antiasalto. Seminuevos: 2% de descuento sobre el listado de precios al público. 10% de descuento en mano de obra de servicios (no preventivos). 10% de mano de obra de taller de Hojalatería y Pintura. 5% en la compra de refacciones y/o accesorios vía mostrador.',
            'Blvd. Puerto Aéreo 134, Col. Moctezuma 2a. Sección, Alcaldía Venustiano Carranza, CDMX. 15530.'
        ]
    },
    {
        id: 29,
        principalImage: Article28,
        title: 'BMW Vecsa',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Descuento del 7.5% en las líneas BMW y BMWi y del 6.5% en la línea MINI.',
            'Vecsa Puebla: Blvd. Atlixcayotl 5316, Reserva Territorial Atlixcayotl, Puebla, Pue. 72190. Vecsa Pachuca:  Distribuidor Vial La Paz 113, Col. Adolfo Lopez Mateos, Pachuca, Hgo. 42094. Vecsa Veracruz: Av. Ejército Mexicano 157, Col. Ylang Ylang, Boca del Río, Ver. 94298. Vecsa Oaxaca: Av. Universidad 400 - Plaza Mía, Col. Ex Hacienda Candiani, Oaxaca, Oax. 68130.'
        ]
    },
    {
        id: 30,
        principalImage: Article29,
        title: 'Automotores Azcapotzalco',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '2% de descuento en la compra de autos seminuevos (VW y otras marcas). En adquisición de autos NUEVOS se otorgará el descuento que establece la planta cada mes. 10% de descuento en en mano de obra en reparaciones del taller, en reparaciones generales. NO APLICA en servicios preventivos.',
            'Av. Tezozómoc 405, Col. Petrolera, Azcapotzalco, CDMX. 02480. Contacto: Alejandro Ramírez Pensado / Cel. 55 4619-1733 / alexramirezpensado@hotmail.com'
        ]
    },
    {
        id: 31,
        principalImage: Article30,
        title: 'Audi Center López Mateos (Guadalajara)',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            '2% de descuento adicional a la promoción/precio del mes, en la adquisición del inventario de unidades nuevas.',
            'Niños Héroes 716, Col. Jardines los Arcos, Guadalajara, Jal. 44120'
        ]
    },
    {
        id: 32,
        principalImage: Article31,
        title: 'Embragues y Frenos Ismael - Monterrey',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Obtén un 10% de descuento sobre el monto total en taller de servicio.',
            'Presenta tu gafete de colaborador vigente. ',
            'No aplica con otras promociones.',
            'Contacto: ',
            'Ruiz Cortines 2000 Ote. esquina con Cipres Col. Moderna, Monterrey, Nuevo León, México. C.P. 64460.',
            'Eugenio Garza Sada 2256 Col. Roma, casi esquina Palestina, Monterrey, N.L. C.P. 64840.',
            'Mariana Garza',
            'Tel: 81 1578 1755',
            'mariana@frenosismael.com'
        ]
    },
    {
        id: 33,
        principalImage: Article32,
        title: 'Goodyear Coronado - CDMX',
        date: '14/03/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Beneficios en la adquisición de llantas, amortiguadores, servicios para automóviles y camionetas.',
        ]
    },
    {
        id: 34,
        principalImage: Article33,
        title: 'Misión/Visión',
        date: '26/05/2025',
        images: [Article331],
        linkLabel: '',
        link: '',
    },
    {
        id: 35,
        principalImage: Article34,
        title: 'Nuestros Principios',
        date: '26/05/2025',
        images: [Article341],
        linkLabel: '',
        link: '',
    },
    {
        id: 36,
        principalImage: Article35,
        title: 'Nuestros Valores',
        date: '26/05/2025',
        images: [Article351],
        linkLabel: '',
        link: '',
    },
    {
        id: 37,
        principalImage: Article36,
        title: 'Service Desk',
        date: '28/05/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Números de serviceDesk',
            '☏ (55)-5022-6500 - Opción 1',
            '☏ (81)-1958-8823 - Opción 1',
            'servicedesk@izzi.mx',
            'Service desk está a disposición para recibir reportes de robos de equipos, deshabilitar cuentas de red y notificar sobre amenazas, como virus y problemas relacionados con seguridad de la información.',
            'Horario:',
            'Lunes a Viernes: 7am - 9pm',
            'Sabado y Domingo: 9am - 5pm'

        ]
    },
    {
        id: 38,
        principalImage: Article37,
        title: 'Servicios de Emergencia',
        date: '28/05/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Números de emergencias',
            'Recuerda estos números telefónicos, para en caso de una emergencia, tengas la asistencia pronta y necesaria',
            'Emergencias: 911',
            'Ángeles Verdes: 078',
            'Cruz Roja: 55 53 95 11 11',
            'LOCATEL: 55 56 58 11 11',
            'Denuncia Anónima: 089 ',
            'Policia Federal: 088',
        ]
    },
    {
        id: 39,
        principalImage: Article38,
        title: 'Atencion GNP',
        date: '28/05/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Asistencia & Contacto',
            '☏ 5552279000',
            'Como reportar un siniestro de Auto a GNP',
            'Realiza el reporte de siniestro a través de alguno de estos canales:',
            'Línea GNP 55 5227 9000, opción 1. (Si requieres ambulancia, puedes solicitarla con el asesor telefónico que atiende tu siniestro).',
            'App Soy Cliente GNP: desde el botón SOS elige “Autos” opción Siniestro.',
            'Información que necesitas para hacer uso de tu Póliza de Seguro de Auto GNP en caso de alguna eventualidad con tu vehículo.',
            'Tener a la mano tu número de Póliza de Seguro de Auto o Moto GNP.',
            'En caso de ser necesario solicita los servicios de emergencia como Bomberos, Cruz Roja, Policía, etcétera, llamando al 911.',
            'Presentar de manera física la licencia correspondiente al tipo de vehículo asegurado.',
            'Reportar el siniestro a GNP de inmediato o a más tardar dentro de las 24 horas siguientes.',
        ]
    },
    {
        id: 40,
        principalImage: Article39,
        title: 'Urgencias Metlife',
        date: '28/05/2025',
        images: [],
        linkLabel: '',
        link: '',
        paragraphs: [
            'Números de Metlife',
            'Disponibles 24/7 para casos de emergencia.',
            '☏  55 5328 7000',
            'Para CDMX y Área metropolitana',
            '☏ 800 00 63854',
            'Para el interior de la República',
            'Si requieres mayor información sobre la cobertura y proceso de contratación llama al tel: 55 5328 9000',
            'San Ángel, ext: 530556',
            '(mtsanangel@metlife.com.mx)',
            'Ana Zamora - 56 4184 2924',
            'Chapultepec, ext: 530561',
            '(mtchapultepec@metlife.com.mx)',
            'Jesús Carbajal - 56 4184 3132',
            'Santa Fe, ext: 530589',
            '(modulotelevisasantafe@metlife.com.mx)',
            'Miguel Trujillo - 56 4184 2348', 
        ]
     },
    {
        id: 41,
        principalImage: Enero,
        title: 'Enero',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 42,
        principalImage: Febrero,
        title: 'Febrero',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 43,
        principalImage: Marzo,
        title: 'Marzo',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 44,
        principalImage: Abril,
        title: 'Abril',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 45,
        principalImage: Mayo,
        title: 'Mayo',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 46,
        principalImage: Junio,
        title: 'Junio',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 47,
        principalImage: Julio,
        title: 'Julio',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 48,
        principalImage: Agosto,
        title: 'Agosto',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 49,
        principalImage: Septiembre,
        title: 'Septiembre',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 50,
        principalImage: Octubre,
        title: 'Octubre',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 51,
        principalImage: Noviembre,
        title: 'Noviembre',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 52,
        principalImage: Diciembre,
        title: 'Diciembre',
        date: 'Calendario 2026',
        images: [],
        linkLabel: '',
        link: ''
    },
    {
        id: 53,
        principalImage: SeguroAuto,
        title: 'Seguro de Auto',
        date: '26/06/2025',
        images: [],
        linkLabel: 'Manual para asegurar tu auto',
        link: 'https://izzitelco.sharepoint.com/sites/servicios-beneficios-izzi/SitePages/seguro-auto.aspx',
        paragraphs: ['Sigue este enlace para consultar como asegurar tu auto:']
    },
];



export const calendar: HomeDataType[] = [
    {
        id:41,
        image: Enero,
        title: 'Enero',
        subtitle: 'Calendario 2026',
    },
    {
        id:42,
        image: Febrero,
        title: 'Febrero',
        subtitle: 'Calendario 2026',
    },
    {
        id:43,
        image: Marzo,
        title: 'Marzo',
        subtitle: 'Calendario 2026',
    },
    {
        id:44,
        image: Abril,
        title: 'Abril',
        subtitle: 'Calendario 2026',
    },
    {
        id:45,
        image: Mayo,
        title: 'Mayo',
        subtitle: 'Calendario 2026',

    },
    {
        id:46,
        image: Junio,
        title: 'Junio',
        subtitle: 'Calendario 2026',

    },
    {
        id:47,
        image: Julio,
        title: 'Julio',
        subtitle: 'Calendario 2026',
    },
    {
        id:48,
        image: Agosto,
        title: 'Agosto',
        subtitle: 'Calendario 2026',
    },
    {
        id:49,
        image: Septiembre,
        title: 'Septiembre',
        subtitle: 'Calendario 2026',
    },
    {
        id:50,
        image: Octubre,
        title: 'Octubre',
        subtitle: 'Calendario 2026',
    },
    {
        id:51,
        image: Noviembre,
        title: 'Noviembre',
        subtitle: 'Calendario 2026',

    },
    {
        id:52,
        image: Diciembre,
        title: 'Diciembre',
        subtitle: 'Calendario 2026',
    }

];


